import { LocalizationOutput } from "@brushfire/types";
import React from "react";

interface UtilitiesContextInterface {
	localization: LocalizationOutput | null;
}

const UtilitiesContext = React.createContext<UtilitiesContextInterface>({
	localization: null,
});

export default UtilitiesContext;
